var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toaster',{attrs:{"timeout":_vm.TOASTER_TIMEOUT},on:{"close-toaster":_vm.close},scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('div',[_c('span',[_vm._v("שם בעל החשבונית עודכן ל"+_vm._s(_vm.name))])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }